/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetUnitRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {GetUnitResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const getUnit = (request: GetUnitRequest, options?: CashRequestOptions) => post<GetUnitRequest, GetUnitResponse>("/2.0/cash/get-unit", request, {...options, rejectOnError: true })